import kycApi from '@/api/now/kycApi'

let userService = {
  postMobileAuthUrl(redirectPage) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postMobileAuthUrl(redirectPage)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postMobileAuthUrlResult() {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postMobileAuthUrlResult()
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postVerifyResidentRegistrationCertificate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postVerifyResidentRegistrationCertificate(data)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postVerifyDriverLicense(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postVerifyDriverLicense(data)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postCdd(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postCdd(data)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  },
  postEdd(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await kycApi.postEdd(data)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    })
  }
}
export default userService
